import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  id: {
    nav_utama: "Utama", nav_monitoring: "Monitoring KPI (PQCDSME)", nav_laporan: "Peningkatan & Laporan", nav_admin: "Administrasi",
    dashboard: "Dashboard", organisasi: "Struktur Organisasi", kpi: "Master KPI Tahunan", realisasi: "Input Realisasi", improvement: "Improvement Sheet",
    laporan: "Laporan Meeting", matrix: "Matrix A4 Triwulan", master: "Master Data", panduan: "Master Panduan", audit: "Audit & Revision Log", pengaturan: "Pengaturan & Review",
    mode_mgmt: "Mode Manajemen", mode_pelaksana: "Mode Pelaksana", tahun: "Tahun", ganti_password: "Ganti Password", keluar: "Keluar", bahasa: "Bahasa",
    st_advance: "Advance", st_on_track: "On Track", st_delay: "Delay", st_not_achieve: "Not Achieve", st_no_data: "Belum ada data",
    total_kpi: "Total KPI", skor_total: "Skor Total", dashboard_title: "Dashboard KPI", masuk: "Masuk ke Y-Navi", masuk_btn: "Masuk",
    oreo_hi: "Halo! OREO siap menemani navigasi KPI-mu.",
    m_senang: "Senang", m_sedih: "Sedih", m_marah: "Marah", m_terkejut: "Terkejut", m_malu: "Malu", m_berpikir: "Berpikir", m_semangat: "Semangat!", m_mengantuk: "Mengantuk",
    m_bingung: "Bingung", m_bagus: "Bagus!", m_luar_biasa: "Luar Biasa!", m_perfect: "Perfect!", m_coba_lagi: "Coba Lagi!",
    c_perfect: "Target tercapai sempurna!", c_luar_biasa: "Di atas target, luar biasa!", c_bagus: "Sesuai jalur, pertahankan!", c_berpikir: "Sedikit tertinggal, ayo kejar.",
    c_coba_lagi: "Belum tercapai — isi Improvement Sheet.", c_mengantuk: "Belum ada data realisasi.", c_bingung: "Tidak ada data untuk ditampilkan.", c_semangat: "Semangat! Mari mulai hari ini.",
    c_sedih: "Skor rendah, perlu perhatian serius.", c_terkejut: "Realisasi tersimpan!",
  },
  ja: {
    nav_utama: "メイン", nav_monitoring: "KPIモニタリング (PQCDSME)", nav_laporan: "改善・レポート", nav_admin: "管理",
    dashboard: "ダッシュボード", organisasi: "組織図", kpi: "年間KPIマスター", realisasi: "実績入力", improvement: "改善シート",
    laporan: "会議レポート", matrix: "A4四半期マトリクス", master: "マスターデータ", panduan: "ガイドマスター", audit: "監査・改訂ログ", pengaturan: "設定・レビュー",
    mode_mgmt: "管理モード", mode_pelaksana: "実行モード", tahun: "年度", ganti_password: "パスワード変更", keluar: "ログアウト", bahasa: "言語",
    st_advance: "前倒し", st_on_track: "順調", st_delay: "遅延", st_not_achieve: "未達成", st_no_data: "データなし",
    total_kpi: "KPI総数", skor_total: "総合スコア", dashboard_title: "KPIダッシュボード", masuk: "Y-Naviにログイン", masuk_btn: "ログイン",
    oreo_hi: "こんにちは！OREOがKPIナビをお手伝いします。",
    m_senang: "うれしい", m_sedih: "かなしい", m_marah: "おこった", m_terkejut: "びっくり", m_malu: "はずかしい", m_berpikir: "かんがえ中", m_semangat: "がんばろう！", m_mengantuk: "ねむい",
    m_bingung: "こまった", m_bagus: "いいね！", m_luar_biasa: "すばらしい！", m_perfect: "パーフェクト！", m_coba_lagi: "もう一度！",
    c_perfect: "目標を完全達成！", c_luar_biasa: "目標超え、すばらしい！", c_bagus: "順調です、この調子！", c_berpikir: "少し遅れ気味、巻き返そう。",
    c_coba_lagi: "未達成 — 改善シートを記入しましょう。", c_mengantuk: "実績データがまだありません。", c_bingung: "表示するデータがありません。", c_semangat: "がんばろう！今日も始めましょう。",
    c_sedih: "スコアが低いです。要注意。", c_terkejut: "実績を保存しました！",
  },
};

const LangCtx = createContext({ lang: "id", setLang: () => {}, t: (k) => k });
const KEY = "ynavi_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(KEY) || "id");
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem(KEY, l); setLangState(l); };
  const t = (k) => DICT[lang]?.[k] ?? DICT.id[k] ?? k;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
export const statusLabel = (t, status) => t(`st_${status || "no_data"}`);
